module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAbElEQVQ4y2NgGBTgkoDJf2yYIcsPP0Y34JZVBBiTZcD9sIL/X46f///lyFkwGyT2/xwDXozhgh837oExjE+SAVckrP/fNA8F4yvSduSFAdmBSMipBL1AsQG1szX+k4MRKYmQXwmFAeUGDGkAAAv9VQ3dyi3eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TG.png
// module id = 1277
// module chunks = 0